<template lang="pug">
  div(class="form-sign-callback")
    h2(class="title-32px fw-700 mb-2") {{ $t('Notification about signature') }}
    div(class="text-14px fw-300") {{ text }}
    div(class="form-sign-callback__form pt-8")
      v-form(@submit.prevent.stop="submit")
        ValidationObserver(
          ref="form"
          slim
        )
          ValidationProvider(
            v-slot="{ errors }"
            tag="div"
            :name="wrapQuotesProviderName($t('Add callbackURL'))"
          )
            v-text-field(
              v-model="callbackUrl"
              :error-messages="errors"
              filled
              :label="$t('Add callbackURL')"
              hide-details="auto"
            )
        div(class="two-buttons-wrapper pt-8")
          v-btn(
            height="48"
            @click="closeModal(false)"
          ) {{ $t('Come back') }}
          v-btn(
            class="main-button"
            type="submit"
            :loading="loading"
          ) {{ $t('Add address') }}
</template>

<script>
import validate from '~/mixins/validation/validate'
import informationSnackbar from '~/modules/snackbar/mixins/informationSnackbar'

export default {
  name: 'FormOrganizationsOnSignCallback',
  mixins: [validate, informationSnackbar],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => {}
    },
    isConcreteTemplate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      callbackUrl: null,
      loading: false
    }
  },
  computed: {
    text() {
      return this.isConcreteTemplate
        ? this.$t(
            'Please specify the address to which Dubidoc will send notifications after signing documents created based on this template'
          )
        : this.$t(
            'Please specify the address to which Dubidoc will send notifications after signing documents'
          )
    }
  },
  created() {
    this.callbackUrl = this._.get(this.item, 'callbackUrl', null)
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }
      try {
        this.loading = true
        const dispatchType = this.isConcreteTemplate ? 'templates/update' : 'organizations/update'
        await this.$store.dispatch(dispatchType, {
          id: this.$route.params.id,
          payload: {
            callbackUrl: this.callbackUrl || null
          }
        })
        this.closeModal(true)
        await this.informationSnackbar.open({
          icon: 'check-circle-white-filled',
          text: this.$t('URL added for getting notifications')
        })
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
